import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { CardDealService } from '../card-deal.service';
import { StorageHelper } from '../helpers/StorageHelper';
import { Global } from '../classes/Global';
import { AuthenticationService } from '../authentication.service';
import { DateHelper } from '../helpers/DateHelper';
import { PriceHelper } from '../helpers/PriceHelper';
import { ModalComponent } from '../modal/modal.component';
import { StringHelper } from '../helpers/StringHelper';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-card-deal-item',
  templateUrl: './card-deal-item.component.html',
  styleUrls: ['./card-deal-item.component.scss'],
  providers: [ CardDealService, AuthenticationService ]
})
export class CardDealItemComponent extends BaseComponent implements OnInit {

  @Input() deal: any;
  @Input() showComments = false;
  @Output() onNoAuth = new EventEmitter();
  @Output() onNewComment = new EventEmitter();

  @ViewChild('expiredPopup', {static: false}) expiredPopup;
  @ViewChild('expiredSuccessPopup', {static: false}) expiredSuccessPopup;
  @ViewChild('notes', {static: true}) notes: ElementRef;

  newCommentText: string = "";
  newSubCommentText: string = "";
  shippingType = {
    '0': this.getString('digital') + ' + ' + this.getString('physical'),
    '1': this.getString('digitalDelivery'),
    '2': this.getString('physical')
  };

  expirationPopupText: string;
  openedAnswer: number = null;

  @Input() showMore: boolean = false;

  constructor(
    private cardDealService: CardDealService,
    private authenticationService: AuthenticationService,
    private sanitizer: DomSanitizer
  ) {
    super();
  }

  ngOnInit() {
    this.expirationPopupText = StringHelper.format(this.getString('expiredConfirmationText'), this.deal.title);
  }

  grabDeal() {
    if((<any>window).gtag) {
      (<any>window).gtag('event', 'GrabDeal', {
        'event_category': 'Card Deal',
        'event_label': this.getDealUrl()
      });
    }

    if ((<any>window)._paq) {
      (<any>window)._paq.push(['trackEvent', "Card Deal", 'GrabDeal', this.getDealUrl()]);
    }
    window.open(this.deal.link, "_blank");
  }

  getCardImg() {
    if(this.deal.cardValue == -1) {
      return "./assets/images/itunes_multiple.png";
    }
    const value = this.deal.cardValue < 10 ? 10 : this.deal.cardValue;
    const currency = Global.countries[Global.getCountry()].currency;
    if(currency == "EUR") {
      return "./assets/images/itunes_euro_" + value + ".png";
    }
    return "./assets/images/itunes_dollar_" + value + ".png";
  }

  openExpiredPopup() {
    if(!this.authenticationService.isLoggedIn()) {
      this.onNoAuth.emit();
      return;
    }
    this.expiredPopup.open();
  }

  reportExpired() {

    this.cardDealService.reportExpired(
      StorageHelper.getInstance().get(StorageHelper.keys.sessionToken),
      Global.getCountry(),
      Global.getStore(),
      this.deal.id
    ).subscribe(res => {
      if(res['status'] == "success") {
        //show success popup
        this.expiredSuccessPopup.open();
      }
    }, err => {
      console.error(err);
    });
  }

  addComment() {

    if(!this.authenticationService.isLoggedIn()) {
      this.onNoAuth.emit();
      return;
    }

    if(this.newCommentText != '') {

      this.cardDealService.addComment(
        StorageHelper.getInstance().get(StorageHelper.keys.sessionToken),
        Global.getCountry(),
        Global.getStore(),
        this.deal.id,
        this.newCommentText
      ).subscribe(res => {
        if(res && res["status"] == "success") {
          this.newCommentText = "";
          this.onNewComment.emit();
        }
      }, err => {

      });

    }

  }

  addCommentToComment(commentId: number) {

    if(!this.authenticationService.isLoggedIn()) {
      this.onNoAuth.emit();
      return;
    }

    if(this.newSubCommentText != '') {

      this.cardDealService.addCommentToComment(
        StorageHelper.getInstance().get(StorageHelper.keys.sessionToken),
        Global.getCountry(),
        Global.getStore(),
        this.deal.id,
        this.newSubCommentText,
        commentId
      ).subscribe(res => {
        if(res && res["status"] == "success") {
          this.newSubCommentText = "";
          this.onNewComment.emit();
        }
      }, err => {

      });

    }

  }

  formatDate(date): string {
    return DateHelper.serverDateToLocaleDateTime(date);
  }

  getCommentsLength(): number {
    if(this.deal && this.deal.comments) {
      return this.deal.comments.length || 0;
    }
    return 0;
  }

  getDealUrl(): string {
    return '/' + Global.getCountry() + '/' + Global.getStoreUrl() + '/' + 'card-deal/' + this.deal.id + '/' +
    StringHelper.slugify(this.deal.title);
  }

  facebookShareURL(): string {
    return "https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.cheapcharts.com%2F" +
      Global.getCountry() + "%2F" + Global.getStoreUrl() + "%2Fcard-deal%2F" + this.deal.id +
    "%2F" + StringHelper.slugify(this.deal.title) +
    "&amp;src=sdkpreparse";
  }

  twitterShareURL(): string {
    return "https://twitter.com/intent/tweet?text=https%3A%2F%2Fwww.cheapcharts.com%2F" +
      Global.getCountry() + "%2F" + Global.getStoreUrl() + "%2Fcard-deal%2F" + this.deal.id +
    "%2F" + StringHelper.slugify(this.deal.title);
  }

  emailShareURL(): string {
    return "mailto:?subject=subject&body=https%3A%2F%2Fwww.cheapcharts.com%2F" +
      Global.getCountry() + "%2F" + Global.getStoreUrl() + "%2Fcard-deal%2F" + this.deal.id +
    "%2F" + StringHelper.slugify(this.deal.title);
  }

  shareClick(platform: string) {
    if((<any>window).gtag) {
      (<any>window).gtag('event', 'Share' + platform, {
        'event_category': 'Card Deal',
        'event_label': this.getDealUrl()
      });
    }
    if ((<any>window)._paq) {
      (<any>window)._paq.push(['trackEvent', "Card Deal", 'Share' + platform, this.getDealUrl()]);
    }
  }

  commentsClick() {
    if((<any>window).gtag) {
      (<any>window).gtag('event', 'Comments', {
        'event_category': 'Card Deal',
        'event_label': this.getDealUrl()
      });
    }
    if ((<any>window)._paq) {
      (<any>window)._paq.push(['trackEvent', "Card Deal", "Comments", this.getDealUrl()]);
    }
    this.showComments =! this.showComments;
  }

  copyURL() {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = window.location.origin + this.getDealUrl();
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    const tooltip = document.getElementById("myCPTooltip" + this.deal.id);
    tooltip.innerHTML = this.getString('copied');
  }

  linkOut() {
    const tooltip = document.getElementById("myCPTooltip" + this.deal.id);
    tooltip.innerHTML = this.getString('copyToClipboard');
  }

  formatPrice(): string {
    return PriceHelper.formatPrice(this.deal.price, Global.countries[Global.getCountry()].currency);
  }

  getAuthorPic(): string {
    const src: string = this.deal && this.deal.author? this.deal.author.profileImageUrl : "placeholder";
    return src.includes('.')? src : "./assets/images/profile_placeholder.png";
  }

  getCommentPic(comment): string {
    const src: string = comment && comment.profileImageUrl? comment.profileImageUrl : "placeholder";
    return src.includes('.')? src : "./assets/images/profile_placeholder.png";
  }

  onExpiredConfirmationResult(result) {
    if(result == ModalComponent.RESULT_YES) {
      this.reportExpired();
    }
  }

  more() {
    this.showMore = true;
  }

  less() {
    this.showMore = false;
  }

  notesAreLong(): boolean {
    if(this.notes) {
      return this.notes.nativeElement.firstChild.offsetHeight > 140;
    }
    return false;
  }

  openAnswer(index: number) {
    this.openedAnswer = index;
  }

  closeAnswer(index: number) {
    this.newSubCommentText = "";
    this.openedAnswer = null;
  }

  isAnswerOpen(index: number): boolean {
    return this.openedAnswer == index;
  }

  formatTextWithLinks(text: string): SafeHtml {
    if(!text) {
      return null;
    }
    const links: string[] = text.split(/\s+/).filter(w => w.indexOf("http") == 0);
    for(let link of links) {
      text = text.replace(link, "<a href='"+link+"' title='"+link+"' target='_blank'>" + link + "</a>");
    }
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  upvote() {

    if(!this.authenticationService.isLoggedIn()) {
      this.onNoAuth.emit();
      return;
    }

    if(this.deal.vote == 1) {
      return;
    }

    this.cardDealService.upvote(
      StorageHelper.getInstance().get(StorageHelper.keys.sessionToken),
      Global.getCountry(),
      Global.getStore(),
      this.deal.id
    ).subscribe(res => {
      if(res['status'] == "success") {
        this.getDeal();
      }
    }, err => {
      console.error(err);
    });
  }

  downvote() {

    if(!this.authenticationService.isLoggedIn()) {
      this.onNoAuth.emit();
      return;
    }

    if(this.deal.vote == -1) {
      return;
    }

    this.cardDealService.downvote(
      StorageHelper.getInstance().get(StorageHelper.keys.sessionToken),
      Global.getCountry(),
      Global.getStore(),
      this.deal.id
    ).subscribe(res => {
      if(res['status'] == "success") {
        this.getDeal();
      }
    }, err => {
      console.error(err);
    });
  }

  getDeal() {
    this.cardDealService.getDeal(
      StorageHelper.getInstance().get(StorageHelper.keys.sessionToken),
      Global.getCountry(),
      Global.getStore(),
      this.deal.id
    ).subscribe(res => {
      if(res) {
        this.deal = res;
      }
    }, err => {
      console.error(err);
    });
  }

}
